// extracted by mini-css-extract-plugin
export default {"component":"SignInFailed__component-zy4J","content":"SignInFailed__content-ZOXp"};